/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Translation_Merge_Error_ToastInputs */

const en_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error merging Event Groups. ${i?.error}`)
};

const fr_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de la fusion des groupes d'evenements. ${i?.error}`)
};

const de_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Zusammenführen der Ereignisgruppen. ${i?.error}`)
};

const it_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'unione dei gruppi di eventi. ${i?.error}`)
};

const ru_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при слиянии групп событий. ${i?.error}`)
};

const es_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al fusionar grupos de eventos. ${i?.error}`)
};

const zh_cn2_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`合并事件组时出错。${i?.error}`)
};

const ja_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント グループの結合中にエラーが発生しました。${i?.error}`)
};

const hi_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट समूहों को मर्ज करने में त्रुटि। ${i?.error}`)
};

const pt_pt2_translation_merge_error_toast = /** @type {(inputs: Translation_Merge_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao mesclar grupos de eventos. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error merging Event Groups. {error}" |
*
* @param {Translation_Merge_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_error_toast = /** @type {((inputs: Translation_Merge_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_error_toast(inputs)
	if (locale === "de") return de_translation_merge_error_toast(inputs)
	if (locale === "it") return it_translation_merge_error_toast(inputs)
	if (locale === "ru") return ru_translation_merge_error_toast(inputs)
	if (locale === "es") return es_translation_merge_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_error_toast(inputs)
	if (locale === "ja") return ja_translation_merge_error_toast(inputs)
	if (locale === "hi") return hi_translation_merge_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_error_toast(inputs)
	return en_translation_merge_error_toast(inputs)
});